export default "__VITE_ASSET__eea66584__"